import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

const vuetify = new Vuetify({
  theme: {
    dark: false,
    themes: {
      light: {
        primary: '#2948ff',
        accent: '#000000',
        secondary: '#17bf95',
        tertiary: '#ff5f9f',
        background: '#161822',
      },
    },
  },
})

export default vuetify